import React from 'react'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import { Card, CardContent, Box, Grid } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import { getRandomArbitrary } from '../../utils/Helpers'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      minWidth: 180,
      height: '100%'
    },
    container: {
      marginBottom: theme.spacing(4)
    },
    title: {
      fontSize: '12pt',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      color: '#4B4B4B',
      fontWeight: 400
    }
  })
)

export default function ChartLineSkeleton (): JSX.Element {
  const classes = useStyles()

  const generatelist = (): JSX.Element[] => {
    const elements: JSX.Element[] = []

    for (let index = 0; index < 8; index++) {
      elements.push(
        <Box width={80} key={`chart-line-skeleton-${getRandomArbitrary(index, 100)}`} height={`${getRandomArbitrary(40, 100)}%`}>
          <Skeleton width="100%" height="100%">
            <div />
          </Skeleton>
        </Box>
      )
    }

    return elements
  }
  const generatelistLeft = (): JSX.Element[] => {
    const elements: JSX.Element[] = []

    for (let index = 0; index < 5; index++) {
      elements.push(
        <Box width="80%" key={`chart-line-skeleton-left-${getRandomArbitrary(index, 100)}`}>
          <Skeleton />
        </Box>
      )
    }

    return elements
  }

  return (
    <Card className={classes.root}>
      <Grid className={classes.container}>
        <CardContent>
          <Box width="100%" className={classes.container}>
            <Skeleton height={32} width="30%" />
          </Box>
          <Box width="100%" height={280} display="flex">
            <Box width="20%" display="flex" flexDirection="column" justifyContent="space-between">
              {generatelistLeft()}
            </Box>
            <Box display="flex" width="80%" height="100%" justifyContent="space-between" alignItems="flex-end">
              {generatelist()}
            </Box>
          </Box>
        </CardContent>
      </Grid>
    </Card>
  )
}
